var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, List, ListItem } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import config from '../Config';
import { addLanguageSlugToUrl } from '../util/PathUtil';
import { frontPageGaData } from './FrontPageBlocks';
import { injectStores } from '../util/StoresUtil';
const BLOCK_NAME = 'Toimingud';
let ActionsBlock = class ActionsBlock extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate, currentLanguage } = this.translateStore;
        return (React.createElement(React.Fragment, null,
            React.createElement(List, { type: "unstyled", bordered: true, fullWidth: true },
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.newSimUrl, currentLanguage), text: translate('actionsBlock.simCardChange'), link: true, iconLeft: "#sim", onClick: () => frontPageGaData(BLOCK_NAME, 'SIM-kaardi vahetus') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.simUrl, currentLanguage), text: translate('actionsBlock.pukCode'), link: true, iconLeft: "#more", onClick: () => frontPageGaData(BLOCK_NAME, 'PUK kood') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.deviceUrl, currentLanguage), text: translate('actionsBlock.deviceInfo'), link: true, iconLeft: "#phone", onClick: () => frontPageGaData(BLOCK_NAME, 'Seadme info') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.contractsUrl, currentLanguage), text: translate('actionsBlock.contracts'), link: true, iconLeft: "#file-edit", onClick: () => frontPageGaData(BLOCK_NAME, 'Lepingud') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.ordersUrl, currentLanguage), text: translate('actionsBlock.orderHistory'), link: true, iconLeft: "#folder", onClick: () => frontPageGaData(BLOCK_NAME, 'Tellimuste ajalugu') })),
                React.createElement(ListItem, null,
                    React.createElement(Button, { url: addLanguageSlugToUrl(config.sendSmsUrl, currentLanguage), text: translate('actionsBlock.sendSms'), link: true, iconLeft: "#chat", onClick: () => frontPageGaData(BLOCK_NAME, 'Saada SMS') })))));
    }
};
ActionsBlock = __decorate([
    injectStores,
    observer
], ActionsBlock);
export default ActionsBlock;
